// 请求接口的统一处理
export const CQ = (quest, returnRes = false) => {
  if (quest) {
    return quest.then((res: any) => {
      const { code, data } = res;
      // status 200 表示接口调用成功
      if (code === "0000") {
        // 返回数据
        // returnRes：true返回res对象
        return returnRes ? { data, res } : data;
      } else {
        console.log("请求失败1");
        console.warn(res);
        const errorData = {
          error: true,
          res
        };
        return returnRes ? { data: errorData, res } : errorData;
      }
    });
  } else {
    const defaultValue = (resolve, reject) => {
      resolve(null);
    };

    var pDV = new Promise(defaultValue);
    return;
    return pDV.then(reason => {
      return reason;
    });
  }
};

export const CQNotWait = (quest, callback) => {
  if (quest) {
    quest.then((res: any) => {
      const { code, data } = res;
      // status 200 表示接口调用成功
      if (code === "0000") {
        // 返回数据
        callback(data);
      } else {
        console.log("请求失败1");
        console.warn(res);
        callback({
          error: true,
          res
        });
      }
    });
  } else {
    // const defaultValue = (resolve, reject) => {
    //   resolve(null);
    // };
    // var pDV = new Promise(defaultValue);
    // return;
    // return pDV.then(reason => {
    //   return reason;
    // });
  }
};
